<template>
    <div class="card fs-7" v-if="order.payment_mode === 'bank_transfer' || order.payment_mode === 'bank_check'">
        <template v-if="order.payment_mode === 'bank_transfer'">
            <div class="card-body">
                <div class="mb-2">
                    Domiciliation bancaire :
                </div>

                BANQUE POPULAIRE ALSACE LORRAINE CHAMPAGNE<br>
                IBAN : FR76 1470 7500 3838 1949 4084 874<br>
                BIC : CCBPFRPPMTZ
            </div>
            <div class="alert alert-warning border-0 mb-0">
                Lors du virement :
                <ul class="pl-4 mb-2">
                    <li>préciser le numéro de la commande</li>
                    <li>envoyer le justificatif de virement à <a href="mailto:formations@culturegrandest.fr">formations@culturegrandest.fr</a></li>
                </ul>
                <p class="mb-2">
                    Le paiement est à réaliser au maximum 7 jours après la commande et doit impérativement nous parvenir avant le début de la formation.
                </p>
                <p class="mb-0">
                    Passé ce délai, votre commande ne pourra plus être prise en considération et sera annulée.
                </p>
            </div>
        </template>
        <template v-if="order.payment_mode === 'bank_check'">
            <div class="card-body">
                <div class="mb-2">
                    Coordonnées (siège social) :
                </div>
                <strong>Agence culturelle Grand Est</strong><br>
                1 route de Marckolsheim – BP 90025<br>
                67601 Sélestat Cedex
            </div>
            <div class="alert alert-warning mb-0 border-0">
                Chèque :
                <ul class="pl-4 mb-2">
                    <li>
                        à libeller au nom de l’« <strong>Agence culturelle Grand Est</strong> »
                    </li>
                    <li>
                        indiquer le <strong>numéro de la commande au dos du chèque</strong>
                    </li>
                    <li>
                        à envoyer à l’adresse ci-dessus
                    </li>
                </ul>
                <p class="mb-2">
                    Le paiement est à réaliser au maximum 7 jours après la commande et doit impérativement nous parvenir avant le début de la formation.
                </p>
                <p class="mb-0">
                    Passé ce délai, votre commande ne pourra plus être prise en considération et sera annulée.
                </p>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            order: Object,
        },
    }
</script>
